import { render, staticRenderFns } from "./ToolGame.vue?vue&type=template&id=d961dbd2&scoped=true&"
import script from "./ToolGame.vue?vue&type=script&lang=js&"
export * from "./ToolGame.vue?vue&type=script&lang=js&"
import style0 from "./ToolGame.vue?vue&type=style&index=0&id=d961dbd2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d961dbd2",
  null
  
)

export default component.exports